import React from 'react';
import { Avatar } from '../../Avatar';

type Props = {
  imageUrl: string;
  content: string;
};

export const ReviewCard = ({ imageUrl, content }: Props): JSX.Element => (
  <div className='w-[361px] h-[180px] bg-emerald-100 flex items-center px-10'>
    <Avatar imageUrl={imageUrl} className='w-[50px] h-[50px]' />
    <p className='text-xs pl-4 leading-5'>{content}</p>
  </div>
);
